const assert = require('@barchart/common-js/lang/assert'),
	is = require('@barchart/common-js/lang/is');

const RemoteType = require('./../RemoteType');

module.exports = (() => {
	'use strict';

	const validator = {
		forQuery: (query, description) => {
			const d = getDescription(description);

			assert.argumentIsRequired(query, d, Object);
			assert.argumentIsRequired(query.type, `${d}.type`, RemoteType, 'RemoteType');
			assert.argumentIsRequired(query.address, `${d}.address`, String);
		}
	};

	function getDescription(description) {
		if (is.string(description)) {
			return description;
		} else {
			return 'registration';
		}
	}

	return validator;
})();
